export default "__VITE_ASSET__BL5_SbE0__"